import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { layout, colorUtils } from 'src/components/base';

import { OutlinedButton } from '@prisjakt/ui/button/variants';
import { Column, Row } from '@prisjakt/ui/list/variants';
import { UserAvatar as UserAvatarComponent } from 'src/components/user-avatar';
import { DropdownToggle as DropdownToggleComponent } from '@prisjakt/ui/dropdown';

export const Buttons = styled.div`
  display: flex;
  flex-direction: column;
  text-align: center;
  margin-top: ${layout.measurements.spacing050};
`;

export const AccountButton = styled(OutlinedButton)`
  &:not(:last-child) {
    margin-bottom: ${layout.measurements.spacing050};
  }
`;

export const SignupLink = styled(Link)`
  color: ${p => p.theme.colors.maybeBlue700};
  text-decoration: underline;

  &:hover {
    color: ${p => p.theme.colors.maybeBlue500};
  }
`;

export const MenuItemLink = styled(Link)`
  display: block;

  &:hover {
    color: ${p => p.theme.text.callToActionHover};
  }
`;

export const ProfileLinks = styled(Column)`
  padding: ${layout.measurements.spacing100};
`;

export const AnalyticsWrapper = styled(Row)`
  align-items: center;

  svg {
    fill: ${p => p.theme.colors.maybeBlue700};
  }
`;

export const DropdownToggle = styled(DropdownToggleComponent)`
  border-radius: 50%;
  background: ${p => p.theme.colors.informative700};
  color: ${p => p.theme.colors.base0};
  width: 40px;
  height: 40px;

  &:hover {
    background: ${p => colorUtils.shadeColor(p.theme.buttons.primary.bg, -20)};
  }
`;

export const UserAvatar = styled(UserAvatarComponent)`
  background: none;

  &:hover {
    background: none;
  }
`;
